import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, of } from 'rxjs';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { NavConfig, NavConfigFn, NavigationConfigProvider } from '@capital-access/common/navigation';
import { Breakpoint } from '@capital-access/firefly/components';
import { REPORTING_PATH } from './constants';

@Injectable()
export class ReportingNavConfigProvider implements NavigationConfigProvider {
  constructor(
    private store: Store,
    @Inject('IS_REPORTING_ENABLED') private readonly isReportingEnabledFeatureToggle$: string
  ) {}

  get isMobile(): boolean {
    const touchDevice = 'ontouchstart' in document.documentElement;
    return (
      /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
      touchDevice ||
      window.innerWidth < Breakpoint.Sm
    );
  }

  resolveNavConfig: NavConfigFn = () => {
    return (
      this.isReportingEnabledFeatureToggle$ != null && this.isReportingEnabledFeatureToggle$ != ''
        ? this.store.select(getFeatureToggle(this.isReportingEnabledFeatureToggle$))
        : of(true)
    ).pipe(
      map(
        isEnabled =>
          ({
            top: [
              {
                localizationKey: 'reporting',
                icon: 'f-i-report',
                order: 700,
                link: REPORTING_PATH,
                enabled: isEnabled && !this.isMobile
              }
            ]
          } as NavConfig)
      )
    );
  };
}
